<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Client Closed Transaction Summary
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-data-table
      :headers="headersSummary"
      :items="summaryValues"
      :loading="loader"
      class="elevation-1 custom-icon-size mb-4"
      :options.sync="options"
      disable-pagination
      hide-default-footer
    >
    </v-data-table>
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Client Closed Transaction List
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-data-table
      :headers="headers"
      :items="list"
      :loading="loader"
      class="elevation-1 custom-icon-size"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:top>
        <v-form>
          <div class="custom-row">
            <v-col cols="12" sm="3" class="pb-0">
              <v-text-field
                label="Receipt key"
                outlined
                v-model="receipt_key"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" class="pb-0">
              <v-text-field
                label="External Receipt Number"
                outlined
                v-model="external_receipt_number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" class="pb-0">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(from_date)"
                    label="From Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    @click:clear="clearDateInput('this.from_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="from_date"
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" class="pb-0">
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(to_date)"
                    label="To Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    @click:clear="clearDateInput('this.to_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="to_date"
                  @input="dateMenuTo = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="12" class="pr-4">
              <v-btn color="white" @click="clearAll" style="float: right"
                >Clear</v-btn
              >
              <v-btn
                color="primary"
                class="success mr-2"
                @click="searchAll"
                style="float: right"
                :loading="loader"
                >Search</v-btn
              >
            </v-col>
          </div>
        </v-form>
        <v-divider class="mb-5"></v-divider>
      </template>
      <template v-slot:[`item.receipt_key`]="{ item }">
        {{ item.receipt_key }}<br />({{ item.external_receipt_number }})
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">
          {{
            item.created_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
          }}</span
        >
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          class="mr-2"
          small
          @click="open(item)"
          v-if="
            checkPermission('app_infor:client_api_closed_transaction_update')
          "
        >
          mdi-pencil
        </v-icon>
      </template>
      <template v-slot:[`item.inbound_closed_date`]="{ item }">
        <span v-if="item.inbound_closed_date">
          {{
            item.inbound_closed_date
              | uaeDateTime
              | moment("DD MMM, YYYY hh:mm A")
          }}</span
        >
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="400">
      <v-form ref="form" class="pt-0 pl-0">
        <v-card>
          <v-card-title class="headline">Add Comment </v-card-title>
          <v-divider class="mb-2"></v-divider>
          <v-card-text class="pb-0 pt-0">
            <v-text-field
              v-model="comment"
              label="Comment"
              outlined
              dense
              class="required"
              :rules="[(v) => !!v || 'Comment is required.']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="pl-4 pt-0">
            <v-btn
              color="green darken-1"
              class="error"
              @click="
                (dialog = false),
                  (comment = ''),
                  (selectedItem = {}),
                  $refs.form.reset()
              "
            >
              Cancel
            </v-btn>
            <v-btn color="primary darken-1" @click="updateItem"> Save </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  components: {},
  computed: {},
  data: () => ({
    options: {},
    from_date: null,
    to_date: null,
    dateMenu: false,
    dateMenuTo: false,
    total: 0,
    summaryValues: [],
    headersSummary: [
      {
        text: "Success Count",
        value: "success_count",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Failed Count",
        value: "failed_count",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Pending Transactions Count since 1 hour",
        value: "pending_count",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    headers: [
      {
        text: "Warehouse",
        value: "warehouse_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Receipt Key (External Receipt)",
        value: "receipt_key",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "120px",
      },

      {
        text: "Comment",
        value: "comment",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created At",
        value: "created_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Closed At",
        value: "inbound_closed_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Action",
        value: "actions",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    list: [],
    loader: false,
    listData: {},
    selectedItem: {},
    dialog: false,
    comment: "",
  }),

  created() {
    this.fetchClientAPiSummary();
  },
  watch: {},
  methods: {
    ...mapActions([
      "getClientApiTracking",
      "clientTrackingRetriger",
      "snackBar",
      "clientTransactionEdit",
    ]),
    updateItem() {
      if (this.$refs.form.validate()) {
        let payload = {
          request_type: "edit",
          comment: this.comment,
        };
        let data = {
          data: payload,
          id: this.selectedItem.id,
        };
        this.clientTransactionEdit(data)
          .then((res) => {
            this.loader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.fetchClientAPiSummary();
            this.dialog = false;
            this.selectedItem = {};
            this.comment = "";
          })
          .catch(() => {
            this.loader = false;
            this.dialog = false;
            this.selectedItem = {};
            this.comment = "";
          });
      }
    },
    clearAll() {
      this.receipt_key = "";
      this.external_receipt_number = "";
      this.from_date = null;
      this.to_date = null;
      this.allFilters();
      this.fetchClientAPiSummary();
    },
    allFilters() {
      this.loader = true;
      let obj = {
        receipt_key: this.receipt_key
          ? this.receipt_key.trim()
          : this.receipt_key,
        external_receipt_number: this.external_receipt_number
          ? this.external_receipt_number.trim()
          : this.external_receipt_number,
        from_date: this.from_date,
        end_date: this.to_date,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    open(item) {
      this.selectedItem = item;
      this.dialog = true;
    },
    clearDateInput(from) {
      if (from == "this.to_date") {
        this.to_date = null;
      } else {
        this.from_date = null;
      }
    },
    searchAll() {
      this.summaryValues = [];
      this.allFilters();
      this.loader = true;

      this.fetchClientAPiSummary();
    },
    fetchClientAPiSummary() {
      this.summaryValues = [];

      this.loader = true;
      let type = {
        summary_type: "closing",
      };
      this.getClientApiTracking({ ...type, ...this.filtersArr })
        .then((res) => {
          this.loader = false;
          this.listData = res.data;
          this.total = res.data.total;
          this.list = res.data.records;
          let obj = {
            failed_count: res.data.failure_count,
            success_count: res.data.success_count,
            pending_count: res.data.pending_since_hour,
          };
          this.summaryValues.push(obj);
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>
<style>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 3px 5px 5px !important;
}
</style>
